import { Injectable } from '@angular/core';

const sanitiseValue = (rawValue) => {
  if (typeof rawValue === 'string') {
    return rawValue.trim();
  } else if (typeof rawValue === 'number' && !isNaN(rawValue)) {
    return String(rawValue);
  }
  return '';
};

@Injectable()
export class RequestOptionsBuilder {

    public static readonly FIELD_PREFIX = 'case.';

    buildOptions(metaCriteria: object, caseCriteria: object, view?: SearchView) {
      let params = {};

      if (view) {
        params['view'] = view;
      }

      if (metaCriteria) {
        for (let criterion of Object.keys(metaCriteria)) {
          params[criterion] = metaCriteria[criterion];
        }
      }

      if (caseCriteria) {
        for (let criterion of Object.keys(caseCriteria)) {
          const value = sanitiseValue(caseCriteria[criterion]);
          if (value.length > 0) {
            params[RequestOptionsBuilder.FIELD_PREFIX + criterion] =  value;
          }
        }
      }

      let options = { params };
      return options;
    }
}

export type SearchView = 'SEARCH' | 'WORKBASKET';
